module.exports = __webpack_public_path__ + "img/banner-1.17165eb.svg";